import SiteLayout, { PageHero } from './SiteLayout';
import { CONTACT } from './siteData';
import { BiMoviePlay } from 'react-icons/bi';

export default function VideosPage() {
  return (
    <SiteLayout>
      <main>
        <PageHero eyebrow="Videos" title="Video stories are coming soon">
          The team is preparing a space for event videos, community moments, and volunteer stories.
        </PageHero>

        <section className="section-padding">
          <div className="container">
            <div className="empty-state empty-state-featured">
              <BiMoviePlay aria-hidden="true" />
              <h2>More stories, soon</h2>
              <p>Until then, follow Raising Smiles on social media or contact the team directly to learn about recent work.</p>
              <a className="btn btn-primary-rs" href={CONTACT.whatsapp} target="_blank" rel="noreferrer">Chat on WhatsApp</a>
            </div>
          </div>
        </section>
      </main>
    </SiteLayout>
  );
}
